/**
 * This function set curr Service ID in window to help web components find the scope
 */
export function setCurrentServiceID(serviceId: number) {
  window['SERVICE_ID'] = serviceId;
}
